<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick"  :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    //接口地址url的统一管理
    import Qs from 'qs'
    import Url from "@/views/other/util/url"
    let isDelete = {"1":"正常数据","2":"禁用"};
    let codeStatus = {"0":"未使用","1":"已使用","2":"已失效","3":"发送失败"};
    let categoryList= {};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        mounted(){
          this.setAddOrUpdate();
        },
        methods: {
          /*表格按钮点击事件*/
          bthClick (clickName, row) {
            if (clickName == "update"){

              this.$refs.childUpdate.open(row);
            }else if (clickName == "delete"){
                this.$axios.get(`${Url.article.deleteBatchId}/${row.id}`).then(res => {
                  if (res.code == 0){
                    this.$refs.childTable.defaultGetData(this.queryData);
                    this.$message.success("suc");
                  }else{
                    this.$message.error(res.message);
                  }
                });


            }else if(clickName == "practice"){
                this.$router.push({path:"/other/tradingGame/learnPractice/list", query: { articleId: row.id ,label:'OHTER'} })
            }
          },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }else if("新增"==clickName){
                  this.$refs.childUpdate.open();
                }
            },

            /*新增或跟提交数据触发事件*/
            submit(model){
                //根据是否包含id更新还是添加
                this.dataChanage(Url.article.addOrUpdate,model,res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, option || {},{ headers: { 'Content-Type': 'application/json' } }).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })

            },
            setAddOrUpdate(){
              this.$axios.get(Url.category.all).then(res => {
                if (res.code == 0){
                  for (let i in res.result) {
                    categoryList[res.result[i].categoryCode] = res.result[i].categoryName;
                  }
                  this.updateData.cols = [
                    { title: '主键', field: 'id',hidden:true},
                    { title: '学习文章类型', field: 'categoryCode',type:2,optionList:categoryList},
                    { title: '学习文章标题', field: 'title'},
                    { title: '学习文章内容', field: 'content',type:6,uploadUrl:Url.img.upload},
                  ]
                }
              });
            },
          getCategory(){
            this.$axios.get(Url.category.all).then(res => {
              if (res.code == 0){
                  this.categoryList = res.result;
              }
            });
          }
        },
        data () {
            return {
                deleteIds:"",
                queryData:{},
                /*新增或更新*/
                updateData:{
                    cols:[]
                },
                /*from查询表单*/
                formData:{
                    hasLable: true,
                    cols:[
                      { title: '标题', field: 'title'},
                        {click:"查询"},
                        {click:"新增"},
                    ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: Url.article.query,
                    selection: true,
                    sequence: true,
                  method:"get",
                    cols: [
                        { title: '学习课程类别', field: 'categoryName'},
                        { title: '学习课程名称', field: 'title'},
                        { title: '体验金', field: 'trialMoney'},
                        { title: '最后操作时间', field: 'updateTime'},
                        {title:"操作",btnClick:[
                          {
                            name:"编辑",click:"update",type:"primary",icon: "el-icon-edit"
                          },
                          {
                            name:"删除",click:"delete",type:"primary",icon:"el-icon-delete"
                          },
                            {
                              name:"关联试题",click:"practice",type:"primary",icon:"el-icon-edit"
                            }
                            ]
                        },
                    ]
                }
            }
        }
    }
</script>
